import { render, staticRenderFns } from "./VersionManagement.vue?vue&type=template&id=23075a67&scoped=true"
import script from "./VersionManagement.vue?vue&type=script&lang=js"
export * from "./VersionManagement.vue?vue&type=script&lang=js"
import style0 from "./VersionManagement.vue?vue&type=style&index=0&id=23075a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23075a67",
  null
  
)

export default component.exports